// extracted by mini-css-extract-plugin
export default {"smsCodeRow":"eRVXl4","sendSms":"MfecfU","text":"SE4wda","disabled":"sTmj1u"};